module.exports = __webpack_public_path__ + "img/logo-sm.1cee2233.png";